import axios from "axios";
import moment from 'moment';
import { convertSortDir } from "../utils";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const getCustomers = async (q, filter_params, page, page_size, sort_by, sort_dir) => {

    let params = filter_params
    params['page'] = page
    params['page_size'] = page_size
    params['q'] = q
    params['sort_by'] = sort_by
    params['sort_dir'] = convertSortDir(sort_dir)

    const res = await axios.get(BACKEND_URL+'/customers', {
        params,
        withCredentials: true
    });
    return res;
}

export const getCustomer = async (id) => {
    const res = await axios.get(BACKEND_URL+`/customers/${id}`, {
        withCredentials: true
    });
    return res;
}

export const createCustomer = async (createObj) => {
    createObj  = Object.fromEntries(Object.entries(createObj).filter(([_, v]) => v !== undefined));
    const res = await axios.post(BACKEND_URL+'/customers',
    createObj,
    {
        withCredentials: true,
        successMessage: "ลูกค้าได้ถูกสร้างแล้ว"
    });
    return res;
}

export const updateCustomer = async (id, updateObj) => {
    const res = await axios.put(BACKEND_URL+`/customers/${id}`,
    updateObj,
    {
        withCredentials: true,
        successMessage: "ลูกค้าได้ถูกแก้ไขแล้ว"
    });
    return res;
}

export const deleteCustomer = async (id) => {
    const res = await axios.delete(BACKEND_URL+`/customers/${id}`,
    {
        withCredentials: true,
        successMessage: "ลูกค้าได้ถูกลบแล้ว"
    });
    return res;
}

export const restoreCustomer = async (id) => {
    const res = await axios.post(BACKEND_URL+`/customers/${id}/restore`,
    {},
    {
        withCredentials: true,
        successMessage: "ลูกค้าได้ถูกกู้คืนแล้ว"
    });
    return res;
}

export const getMapCustomers = async (branchId, routeId) => {
    let params = {}
    params['branch_id'] = branchId
    params['route_id'] = routeId
    const res = await axios.get(BACKEND_URL+'/customers/get_map', {
        params,
        withCredentials: true
    });
    return res;
}

export const exportCustomerExcel = async (branchId, routeId, branchName, routeName) => {
    let params = {}
    params['branch_id'] = branchId
    params['route_id'] = routeId
    const res = await axios.post(BACKEND_URL+'/customers/excel', {}, {
        params,
        withCredentials: true,
        successMessage: "Excel ได้ถูกดาวน์โหลดแล้ว",
        responseType: 'blob'
    });
    let fileName = routeName ? routeName : branchName
    if (fileName === undefined) {
        fileName = "รวมมิตรทุกสาขา"
    }
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `ลูกค้า ${fileName} ${moment(new Date()).format("DD/MM/YYYY HH:mm")}.xlsx`);
    document.body.appendChild(link);
    link.click();
}